

import { useContext, useEffect, useRef, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';
import { MerchantsContext } from '../../context/merchants/MerchantContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { BanksContext } from '../../context/bank/BankContext';
import { AuthContext } from '../../context/auth';
import Message from '../../components/ui/Message';
import { useRequiredFields } from '../../hooks/useRequiredFields';
import topApi from '../../components/api/ToPApi';
import BankOptions from '../../components/ui/BankOptions';
import MerchantPicker from '../../components/ui/MerchantPicker';
import { normalizePanamaId, panamaIdError, panamaIdHasDv } from '../../utils/panamaId';




export const MerchantPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const [showBank, setShowBank] = useState(false);
    const { addMerchant, updateMerchant, loadMerchantTypes, loadExecutives, loadMerchantIdTypes } = useContext(MerchantsContext);
    //const { banks } = useContext(BanksContext);
    const { user } = useContext(AuthContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const [multicurrency, setMulticurrency] = useState(false);
    const [types, setTypes] = useState([]);
    const [executives, setExecutives] = useState([]);
    const [idTypes, setIdTypes] = useState([]);




    var merchant;

    if (state) {

        merchant = state.merchant;
        merchant.terminal_id = merchant.topId != null ? merchant.topId.toString() : '';
        merchant.terminal_id_dol = merchant.topIdDol != null ? merchant.topIdDol.toString() : null;
        merchant.address = state.merchant.address != null ? state.merchant.address : "";
        merchant.hasMerchantEcom = state.merchant.hasMerchantEcom ? 1 : 0;
        merchant.hasMerchantTop = state.merchant.hasMerchantTop ? 1 : 0;
        merchant.image = merchant.image ?? '';
        merchant.itbms = merchant.itbms ?? '';
        merchant.transactionLimitDol = merchant.transactionLimitDol ?? '';
        merchant.parentId = merchant.parentId ?? null;
        merchant.dv = merchant.dv ?? '';

    } else {
        merchant = {
            id: -1,
            country_id: 1,
            merchant_code: '',
            name: '',
            terminal_id: "",
            //contract_code: "",
            bank_id: -1,
            currency_code: '188',
            //category_code: '',
            //city: '',
            address: '',
            //zipCode: '',
            terminal_id_dol: '',
            terminalDefault: CURRENCY_CRC,

            activityCode: '',
            electronicInvoice: false,
            executiveId: 1,
            monthlyRate: '',
            invoiceRate: '',
            paymentRatePercentage: '',
            maxLevel: '',
            vat: '',
            itbms: '',
            parentId: null,
            dv: '',
            paymentEmail: '',
            documentNumber: '',
            companyTypeId: '',
            // Sin límite por transacción: en 0 las apps no validan el monto
            transactionLimit: 0,
            transactionLimitDol: 0,
            typeLegalId: '',
            ecomId: '',
            ecomBankId: 1,
            topBankId: 1,
            bankId: '',
            hasMerchantEcom: 0,
            hasMerchantTop: 0,
            settlementCost: '',
            emailDeposit: '',
            image: '',
            swiftpayCost: '0.5',
            swiftSync: false
        }
    }


    const { formState, onInputChange } = useForm(merchant);

    // Banco afiliador: la plataforma elige; un usuario de banco solo ve el suyo (el API lo impone)
    const [banks, setBanks] = useState<{ id: number; name: string; status?: string; countryId?: number }[]>([]);
    useEffect(() => {
        topApi.get<{ banks: { id: number; name: string; status?: string; countryId?: number }[] }>('/bank/getBanks')
            .then(resp => {
                const active = (resp.data.banks ?? []).filter(bank => bank.status !== 'INA');
                setBanks(active);
                if (active.length === 1 && !formState.bankId) {
                    onInputChange({ target: { name: 'bankId', value: String(active[0].id) } });
                }
            })
            .catch(() => setBanks([]));
    }, []);   // eslint-disable-line react-hooks/exhaustive-deps

    const { id, name, itbms, dv, parentId, bank_id, terminal_id, terminal_id_dol, terminalDefault,
        currency_code, address, activityCode,
        electronicInvoice,
        executiveId,
        monthlyRate,
        invoiceRate,
        paymentRatePercentage,
        maxLevel,
        vat,
        paymentEmail,
        documentNumber,
        companyTypeId, typeLegalId, ecomId,
        ecomBankId,
        topBankId,
        bankId,
        hasMerchantEcom,
        hasMerchantTop,
        settlementCost,
        emailDeposit,
        image,
        swiftpayCost,
        swiftSync
    } = formState

    // Cadena: el comercio puede ser sucursal de una casa matriz del mismo banco (un solo nivel)
    const branchCount = Number(state?.merchant?.branchCount ?? 0);
    const [isBranch, setIsBranch] = useState(Number(parentId) > 0);
    const branchInvalid = isBranch && !(Number(parentId) > 0);
    const setParent = (value: number | null) => onInputChange({ target: { name: 'parentId', value } });
    // La casa matriz es del mismo banco: si cambia el banco se vuelve a elegir
    const initialBank = useRef(bankId);
    useEffect(() => {
        if (String(bankId) !== String(initialBank.current) && parentId) setParent(null);
        initialBank.current = bankId;
    }, [bankId]);   // eslint-disable-line react-hooks/exhaustive-deps

    // El país del comercio es el de su banco. Panamá no usa terminal ni la mayoría de configuraciones adicionales.
    const countryId = Number(banks.find(bank => bank.id === Number(bankId))?.countryId) || null;
    const isPanama = countryId === PANAMA_COUNTRY_ID;
    const hasElectronicInvoice = electronicInvoice == true || electronicInvoice == "1";
    // Formato de la identificación de Panamá: solo al crear (al editar no se puede cambiar).
    // El extranjero (pasaporte) no tiene DV, así que no puede emitir factura electrónica.
    const hasDv = panamaIdHasDv(typeLegalId);
    const idError = !isPanama || id > 0 || !(typeLegalId > 0) ? null
        : panamaIdError(typeLegalId, documentNumber) ?? (!hasDv && hasElectronicInvoice ? 'La factura electrónica requiere RUC o NT con DV.' : null);
    // DV del RUC: visible en Panamá (salvo extranjero); obligatorio con factura electrónica, opcional sin ella (si se digita, 1 o 2 dígitos)
    const dvText = String(dv ?? '').trim();
    const dvValid = !hasDv || (hasElectronicInvoice ? DV_PATTERN.test(dvText) : dvText === '' || DV_PATTERN.test(dvText));

    useEffect(() => {
        if (isPanama) {
            if (!emailDeposit) onInputChange({ target: { name: 'emailDeposit', value: PANAMA_DEPOSIT_EMAIL } });
            if (itbms === '' || itbms == null) onInputChange({ target: { name: 'itbms', value: PANAMA_ITBMS } });
            // Panamá opera en dólares
            if (String(terminalDefault) !== CURRENCY_USD) onInputChange({ target: { name: 'terminalDefault', value: CURRENCY_USD } });
        } else if (id <= 0) {
            // Al cambiar a un banco de otro país se quitan los valores por defecto de Panamá
            if (emailDeposit === PANAMA_DEPOSIT_EMAIL) onInputChange({ target: { name: 'emailDeposit', value: '' } });
            if (String(terminalDefault) === CURRENCY_USD) onInputChange({ target: { name: 'terminalDefault', value: CURRENCY_CRC } });
        }
    }, [isPanama]);   // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const common = Number(bankId) > 0 && name.length > 0 && address.length > 0 && companyTypeId > 0 && typeLegalId > 0;
        const formValid = isPanama
            ? common && String(documentNumber ?? '').trim().length > 0 && !idError && image.length > 0 && dvValid
            : common && terminal_id.length > 0 && activityCode.length > 0 && image.length > 0 && emailDeposit.length > 0;
        setIsFormValid(formValid && !branchInvalid);
    }, [branchInvalid, name, terminal_id, address, terminalDefault, activityCode, companyTypeId, typeLegalId, image, emailDeposit, bankId, isPanama, documentNumber, idError, dvValid])





    // Tipos de empresa e identificación del país del banco elegido
    useEffect(() => {
        if (!countryId) return;
        let active = true;
        Promise.all([loadMerchantTypes(countryId), loadMerchantIdTypes(countryId)]).then(([companyTypes, legalTypes]) => {
            if (!active) return;
            setTypes(companyTypes ?? []);
            setIdTypes(legalTypes ?? []);
            // Al crear, si cambió el país se limpian las opciones que ya no aplican
            if (id <= 0) {
                if (!(companyTypes ?? []).some((type: any) => String(type.id) === String(companyTypeId))) onInputChange({ target: { name: 'companyTypeId', value: '' } });
                if (!(legalTypes ?? []).some((type: any) => String(type.id) === String(typeLegalId))) onInputChange({ target: { name: 'typeLegalId', value: '' } });
            }
        });
        return () => { active = false; };
    }, [countryId]);   // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        loadExecutives().then((executives) => {
            setExecutives(executives)
        });
    }, [])

    useEffect(() => {
        const multi = process.env.REACT_APP_MULTICURRENCY
        setMulticurrency(multi != null && multi == "true");
    }, [])


    const handleSave = async () => {
        if (!isFormValid) {
            required.fail();
            setErrorMessage(idError ?? "Debe completar los campos requeridos.");
            return;
        }
        var resp = "";

        if (formState.settlementCost == '') {
            formState.settlementCost = 0;
        }
        if (isPanama) {
            // Sin terminal TOP
            formState.terminal_id = null;
            formState.terminal_id_dol = null;
            formState.terminalDefault = CURRENCY_USD;
            formState.dv = hasDv ? dvText || null : null;
            if (id <= 0) formState.documentNumber = normalizePanamaId(documentNumber);
        }

        // Límites ocultos en el formulario: vacío o 0 = sin límite
        formState.transactionLimit = Number(formState.transactionLimit) || 0;
        formState.transactionLimitDol = Number(formState.transactionLimitDol) || 0;

        formState.parentId = isBranch ? Number(parentId) || null : null;
        delete formState.parent;        // datos del listado, no se guardan
        delete formState.branchCount;

        if (id > 0) {
            resp = await updateMerchant(formState);
        } else {
            resp = await addMerchant(formState);
            setErrorMessage("Ocurrió un error actualizando el comercio.");
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Comercio actualizado correctamente" : "Comercio creado correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }



    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-8'>
                <h3>{id > 0 ? 'Actualizar comercio' : 'Crear comercio'}</h3>
                <hr />

                <form className="row" >

                    <div className='row' style={{ paddingBottom: '2%' }}>
                        <div > <h5>Información general</h5></div>

                        <div className="col-12 mb-3">
                            <label htmlFor="merchantBankSelect" className="form-label">Banco afiliador *</label>
                            <select id='merchantBankSelect' className={`form-select${required.mark(!(Number(bankId) > 0))}`} name='bankId'
                                value={bankId ?? ''} onChange={onInputChange} disabled={banks.length <= 1}>
                                <option value="">Seleccione el banco</option>
                                <BankOptions banks={banks} />
                            </select>
                            <div className="invalid-feedback">Campo requerido</div>
                            <div className="form-text">Banco al que pertenece el comercio; sus usuarios de banco lo administran.</div>
                        </div>

                        <div className="col-12 mb-3">
                            <label className="form-label d-block">Cadena</label>
                            {branchCount > 0 ? (
                                <div className="form-text mt-0">
                                    <i className="bi bi-diagram-3 me-1" />
                                    Casa matriz de {branchCount} sucursal(es). Para agregar otra, cree el comercio y márquelo como sucursal de este.
                                </div>
                            ) : (
                                <>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch" id="isBranchSwitch"
                                            checked={isBranch} disabled={!(Number(bankId) > 0)}
                                            onChange={(e) => { setIsBranch(e.target.checked); if (!e.target.checked) setParent(null); }} />
                                        <label className="form-check-label" htmlFor="isBranchSwitch">Es sucursal de una cadena</label>
                                    </div>
                                    {isBranch && (
                                        <div className="mt-2">
                                            <label htmlFor="parentMerchantPicker" className="form-label">Casa matriz *</label>
                                            <MerchantPicker
                                                key={String(bankId)}
                                                id="parentMerchantPicker"
                                                value={Number(parentId) > 0 ? Number(parentId) : -1}
                                                allowAll={false}
                                                allLabel="Busque la casa matriz"
                                                selectedLabel={state?.merchant?.parent?.name ?? ''}
                                                params={{ parentsOnly: '1', bankId: String(bankId ?? ''), ...(id > 0 ? { excludeId: String(id) } : {}) }}
                                                invalid={required.mark(branchInvalid) !== ''}
                                                onChange={(merchantId) => setParent(merchantId > 0 ? merchantId : null)}
                                            />
                                            <div className="form-text">
                                                La sucursal tiene sus propios usuarios, grupos y terminal. La casa matriz puede consultar sus transacciones.
                                            </div>
                                        </div>
                                    )}
                                    {!isBranch && <div className="form-text">Comercio independiente o casa matriz de una cadena.</div>}
                                </>
                            )}
                        </div>

                        <div className="col ">
                            <label htmlFor="merchantIdTypeSelect" className="form-label">Tipo Identificación *</label>
                            <select id='merchantIdTypeSelect' className={`form-select${required.mark(!(typeLegalId > 0))}`} name='typeLegalId' disabled={state != null} value={typeLegalId} onChange={onInputChange} >
                                <option key={-1} value={-1} >Seleccione una opción</option>
                                {idTypes.length > 0
                                    ?
                                    idTypes.map(productPrincipal => (
                                        <option key={productPrincipal.id} value={productPrincipal.id} >{productPrincipal.format ? `${productPrincipal.description} (${productPrincipal.format})` : productPrincipal.description}</option>
                                    ))
                                    :
                                    ''
                                }
                            </select>
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>

                        <div className="col">
                            <label htmlFor="documentNumberInput" className="form-label">{isPanama ? 'Identificación *' : 'Identificación'}</label>
                            <input
                                id='documentNumberInput'
                                type="text"
                                className={`form-control${isPanama ? required.mark(!String(documentNumber ?? '').trim() || !!idError) : ''}`}
                                placeholder={isPanama ? idTypes.find((type: any) => String(type.id) === String(typeLegalId))?.format ?? 'Cédula o RUC' : 'Cédula física o jurídica'}
                                name="documentNumber"
                                value={documentNumber}
                                onChange={onInputChange}
                                disabled={state != null}
                            />
                            <div className="invalid-feedback">{idError && String(documentNumber ?? '').trim() ? idError : 'Campo requerido'}</div>
                        </div>

                        {isPanama && hasDv && (
                            <div className="col-2">
                                <label htmlFor="dvInput" className="form-label">{hasElectronicInvoice ? 'DV *' : 'DV'}</label>
                                <input
                                    id='dvInput'
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={2}
                                    className={`form-control${required.mark(!dvValid)}`}
                                    placeholder="DV"
                                    name="dv"
                                    value={dv ?? ''}
                                    onChange={onInputChange}
                                />
                                <div className="invalid-feedback">{hasElectronicInvoice ? 'Requerido: 1 o 2 dígitos' : '1 o 2 dígitos'}</div>
                            </div>
                        )}




                    </div>

                    <div className='row' style={{ paddingBottom: '2%' }}>



                        <div className="col">
                            <label htmlFor="merchantNameInput" className="form-label">Nombre comercio *</label>
                            <input
                                id='merchantNameInput'
                                type="text"
                                className={`form-control${required.mark(!name)}`}
                                placeholder="Nombre comercio"
                                name="name"
                                value={name}
                                onChange={onInputChange}

                                required
                            />
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>

                    </div>
                    <div className='row' style={{ paddingBottom: '2%' }}>
                        <div className="col">
                            <label htmlFor="addressInput" className="form-label">Dirección *</label>
                            <textarea
                                id='addressInput'
                                maxLength={250}
                                rows={2}
                                className={`form-control${required.mark(!address)}`}
                                placeholder="Dirección"
                                name="address"
                                value={address}
                                onChange={onInputChange}
                                required
                            />
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>
                    </div>
                    {!isPanama && <div className='mt-5'> <h5>Información terminal</h5></div>}

                    {
                        isPanama ? null : multicurrency ?
                            (
                                <>
                                    <div className='row' style={{ paddingBottom: '2%' }}>
                                        <div className="col">
                                            <label htmlFor="terminalIdInput" className="form-label">Número terminal (Top) *</label>
                                            <input
                                                id='terminalIdInput'
                                                type="text"
                                                className={`form-control onlyInteger${required.mark(!terminal_id)}`}
                                                placeholder="Número terminal"
                                                name="terminal_id"
                                                value={terminal_id}
                                                onChange={onInputChange}
                                                required
                                            />
                                            <div className="invalid-feedback">Campo requerido</div>
                                        </div>
                                        <div className="col visually-hidden">
                                            <label htmlFor="currencyCodeSelect" className="form-label">Moneda terminal</label>
                                            <select id='currencyCodeSelect' className="form-select" name='currency_code' value={currency_code} onChange={onInputChange} defaultValue={"188"} >
                                                <option value="188">Colones</option>
                                            </select>
                                        </div>

                                        <div className="col">
                                            <label htmlFor="terminalIdDolInput" className="form-label">Número terminal dólares (Top)</label>
                                            <input
                                                id='terminalIdDolInput'
                                                type="text"
                                                className="form-control onlyInteger"
                                                placeholder="Número terminal dólares"
                                                name="terminal_id_dol"
                                                value={terminal_id_dol}
                                                onChange={onInputChange}
                                                required
                                            />
                                        </div>

                                    </div>
                                    <div className='row' style={{ paddingBottom: '2%' }}>
                                        <div className="col-md-6">
                                            <label htmlFor="terminalDefaultSelect" className="form-label">Terminal predeterminada</label>
                                            <select id='terminalDefaultSelect' className="form-select" name='terminalDefault' value={terminalDefault} onChange={onInputChange} defaultValue={"188"} >
                                                <option value="188">Colones</option>
                                                <option value="840">Dólares</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row' style={{ paddingBottom: '2%' }}>
                                        <div className="col-6">
                                            <label htmlFor="ecomIdEComInput" className="form-label">Terminal e-commerce</label>
                                            <input
                                                id='ecomIdEComInput'
                                                type="text"
                                                className="form-control"
                                                placeholder="Terminal e-commerce"
                                                name="ecomId"
                                                value={ecomId}
                                                onChange={onInputChange}
                                            />
                                        </div>


                                    </div>

                                    <div className='row' style={{ paddingBottom: '2%' }}>

                                        <div className="col-md-6">
                                            <label htmlFor="ecomBankIdSelect" className="form-label">Banco terminal e-commerce</label>
                                            <select id='ecomBankIdSelect' className="form-select" name='ecomBankId' value={ecomBankId} onChange={onInputChange} defaultValue={"188"} >
                                                <option value="1">Swiftpay</option>
                                                <option value="2">Banco Nacional de Costa Rica</option>
                                            </select>
                                        </div>

                                        <div className="col-md-6">
                                            <label htmlFor="topBankIdSelect" className="form-label">Banco terminal TOP</label>
                                            <select id='topBankIdSelect' className="form-select" name='topBankId' value={topBankId} onChange={onInputChange} defaultValue={"188"} >
                                                <option value="1">Swiftpay</option>
                                                <option value="2">Banco Nacional de Costa Rica</option>
                                            </select>
                                        </div>

                                    </div>

                                    <div className='row' style={{ paddingBottom: '2%' }}>
                                        <div className="col-md-6">
                                            <label htmlFor="hasMerchantEcomSelect" className="form-label">Tiene terminal e-commerce</label>
                                            <select id='hasMerchantEcomSelect' className="form-select" name='hasMerchantEcom' value={hasMerchantEcom} onChange={onInputChange} defaultValue={"0"} >
                                                <option value="0">No</option>
                                                <option value="1">Sí</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="hasMerchantTopSelect" className="form-label">Tiene terminal TOP propio</label>
                                            <select id='hasMerchantTopSelect' className="form-select" name='hasMerchantTop' value={hasMerchantTop} onChange={onInputChange} defaultValue={"0"} >
                                                <option value="0">No</option>
                                                <option value="1">Sí</option>
                                            </select>
                                        </div>

                                    </div>

                                </>
                            )
                            :
                            (
                                <div className='row' style={{ paddingBottom: '2%' }}>
                                    <div className="col">
                                        <label htmlFor="terminalIdSingleInput" className="form-label">Número terminal (Top) *</label>
                                        <input
                                            id='terminalIdSingleInput'
                                            type="text"
                                            className={`form-control onlyInteger${required.mark(!terminal_id)}`}
                                            placeholder="Número terminal"
                                            name="terminal_id"
                                            value={terminal_id}
                                            onChange={onInputChange}
                                            required
                                        />
                                        <div className="invalid-feedback">Campo requerido</div>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="currencyCodeSelect" className="form-label">Moneda terminal</label>
                                        <select id='currencyCodeSelect' className="form-select" name='currency_code' value={currency_code} onChange={onInputChange}  >
                                            <option key={0} value={-1} >Seleccione una opción</option>
                                            <option value="188">Colones</option>
                                            <option selected value="840">Dólares</option>
                                        </select>
                                    </div>
                                </div>
                            )
                    }

                    <div className='mt-5'> <h5>Configuraciones adicionales</h5></div>
                    <div className='row' style={{ paddingBottom: '2%' }}>


                        <div className={`col${isPanama ? ' d-none' : ''}`}>
                            <label htmlFor="activityCodeInput" className="form-label">Código actividad *</label>
                            <input
                                id='activityCodeInput'
                                type="text"
                                className={`form-control${required.mark(!activityCode)}`}
                                placeholder="Código actividad"
                                name="activityCode"
                                value={activityCode}
                                onChange={onInputChange}

                                required
                            />
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>

                        <div className={`col`}>
                            <label className="form-label" htmlFor="electronicInvoiceCheck">Factura electronica</label>
                            <select id='electronicInvoiceCheck' className="form-select" name='electronicInvoice' value={electronicInvoice == true || electronicInvoice == "1" ? 1 : 0} onChange={onInputChange}  >
                                <option key={1} value={1} >Sí</option>
                                <option key={2} value={0} >No</option>
                            </select>

                        </div>
                    </div>

                    <div className={`row${isPanama ? ' d-none' : ''}`} style={{ paddingBottom: '2%' }}>

                        <div className="col">
                            <label htmlFor="monthlyRateInput" className="form-label">Tarifa mensual</label>
                            <input
                                id='monthlyRateInput'
                                type="text"
                                className="form-control"
                                placeholder="Tarifa mensual"
                                name="monthlyRate"
                                value={monthlyRate}
                                onChange={onInputChange}
                            />
                        </div>

                        <div className="col">
                            <label htmlFor="invoiceRateInput" className="form-label">Tarifa factura</label>
                            <input
                                id='invoiceRateInput'
                                type="text"
                                className="form-control"
                                placeholder="Tarifa factura"
                                name="invoiceRate"
                                value={invoiceRate}
                                onChange={onInputChange}
                            />
                        </div>

                    </div>

                    <div className={`row${isPanama ? ' d-none' : ''}`} style={{ paddingBottom: '2%' }}>

                        <div className="col">
                            <label htmlFor="paymentRatePercentageInput" className="form-label">Porcentaje tarifa pago</label>
                            <input
                                id='paymentRatePercentageInput'
                                type="text"
                                className="form-control"
                                placeholder="Porcentaje tarifa pago"
                                name="paymentRatePercentage"
                                value={paymentRatePercentage}
                                onChange={onInputChange}
                            />
                        </div>

                        <div className="col">
                            <label htmlFor="maxLevelInput" className="form-label">Nivel máximo</label>
                            <input
                                id='maxLevelInput'
                                type="text"
                                className="form-control"
                                placeholder="Nivel máximo"
                                name="maxLevel"
                                value={maxLevel}
                                onChange={onInputChange}


                            />
                        </div>

                    </div>

                    <div className='row' style={{ paddingBottom: '2%' }}>

                        <div className={`col${isPanama ? ' d-none' : ''}`}>
                            <label htmlFor="vatInput" className="form-label">IVA</label>
                            <input
                                id='vatInput'
                                type="text"
                                className="form-control"
                                placeholder="IVA"
                                name="vat"
                                value={vat}
                                onChange={onInputChange}
                            />
                        </div>

                        <div className="col">
                            <label htmlFor="paymentEmailInput" className="form-label">Correo</label>
                            <input
                                id='paymentEmailInput'
                                type="text"
                                className="form-control"
                                placeholder="Correo"
                                name="paymentEmail"
                                value={paymentEmail}
                                onChange={onInputChange}
                            />
                            <div className="form-text">Puede ingresar varios correos separados por ;</div>
                        </div>

                    </div>

                    <div className={`row${isPanama ? ' d-none' : ''}`} style={{ paddingBottom: '2%' }}>

                        <div className="col">
                            <label htmlFor="settlementInput" className="form-label">Costo liquidación</label>
                            <input
                                id='settlementInput'
                                type="text"
                                className="form-control"
                                placeholder="Costo liquidación"
                                name="settlementCost"
                                value={settlementCost}
                                onChange={onInputChange}
                            />
                        </div>

                        <div className="col">
                            <label htmlFor="depostEmailInput" className="form-label">Correo depósito *</label>
                            <input
                                id='depostEmailInput'
                                type="text"
                                className={`form-control${required.mark(!emailDeposit)}`}
                                placeholder="Correo depósito"
                                name="emailDeposit"
                                value={emailDeposit}
                                onChange={onInputChange}
                            />
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>

                    </div>

                    <div className={`row${isPanama ? ' d-none' : ''}`} style={{ paddingBottom: '2%' }}>

                        <div className="col">
                            <label htmlFor="swiftpayCostInput" className="form-label">Costo swiftpay</label>
                            <input
                                id='swiftpayCostInput'
                                type="text"
                                className="form-control"
                                placeholder="Costo Swiftpay (0.5 o 1.5)"
                                name="swiftpayCost"
                                value={swiftpayCost}
                                onChange={onInputChange}
                            />
                        </div>

                        <div className="col">
                            <label htmlFor="depostEmailInput" className="form-label">Integración Sist. Facturacion Escritorio</label>
                            <select id='swiftSyncSelect' className="form-select" name='swiftSync' value={swiftSync == true || swiftSync == "1" ? 1 : 0} onChange={onInputChange}  >
                                <option key={1} value={1} >Sí</option>
                                <option key={2} value={0} >No</option>
                            </select>
                        </div>

                    </div>

                    <div className='row' style={{ paddingBottom: '2%' }}>

                        <div className={`col${isPanama ? ' d-none' : ''}`}>
                            <label htmlFor="executiveSelect" className="form-label">Ejecutivo</label>
                            <select id='executiveSelect' className="form-select" name='executiveId' value={executiveId} onChange={onInputChange} >
                                <option key={-1} value={-1} >Seleccione una opción</option>
                                {executives.length > 0
                                    ?
                                    executives.map(productPrincipal => (
                                        <option key={productPrincipal.id} value={productPrincipal.id} >{productPrincipal.name}</option>
                                    ))
                                    :
                                    ''
                                }
                            </select>
                        </div>

                        <div className={isPanama ? 'col-6' : 'col'}>
                            <label htmlFor="merchantTypeSelect" className="form-label">Tipo empresa *</label>
                            <select id='merchantTypeSelect' className={`form-select${required.mark(!(companyTypeId > 0))}`} name='companyTypeId' value={companyTypeId} onChange={onInputChange} >
                                <option key={-1} value={-1} >Seleccione una opción</option>
                                {types.length > 0
                                    ?
                                    types.map(productPrincipal => (
                                        <option key={productPrincipal.id} value={productPrincipal.id} >{productPrincipal.description}</option>
                                    ))
                                    :
                                    ''
                                }
                            </select>
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>



                    </div>

                    <div className='row' style={{ paddingBottom: '2%' }}>

                        <div className="col-6">
                            <label htmlFor="imageInput" className="form-label">Url logo empresa *</label>
                            <input
                                id='imageInput'
                                type="text"
                                className={`form-control${required.mark(!image)}`}
                                placeholder="Logo empresa"
                                name="image"
                                value={image}
                                onChange={onInputChange}
                            />
                            <div className="invalid-feedback">Campo requerido</div>
                        </div>



                    </div>




                    {/* <div className='row' style={{paddingBottom: '2%'}}>
                <div className="col">
                        <label htmlFor="contractCodeInput" className="form-label">Número afiliado (Core)</label>
                        <input 
                            id='contractCodeInput'
                            type="text" 
                            className="form-control onlyInteger"
                            placeholder="Número afiliado"
                            name="contract_code"
                            value={ contract_code }
                            onChange={ onInputChange }
                            required 
                        />
                        
                    </div>

                    <div className="col">
                        <label htmlFor="category_codeInput" className="form-label">Código de categoria (MCC)</label>
                        <input 
                            id='category_codeInput'
                            type="text" 
                            className="form-control onlyInteger"
                            placeholder="Código de categoria"
                            name="category_code"
                            value={ category_code }
                            onChange={ onInputChange }
                            required 
                        />
                    </div>        
                </div> */}

                    {/*<div className='row' style={{paddingBottom: '2%'}}>
                    <div style={{paddingBottom: '2%', marginTop:'3%'}}> <h5>Datos dirección</h5></div>
                    <div className="col">
                        <label htmlFor="cityInput" className="form-label">Ciudad</label>
                        <input 
                            id='cityInput'
                            type="text" 
                            maxLength={50}
                            className="form-control"
                            placeholder="Ciudad"
                            name="city"
                            value={ city }
                            onChange={ onInputChange }
                            required 
                        />
                        
                    </div>
                    
                    <div className="col">
                        <label htmlFor="zipCodeInput" className="form-label">Código postal</label>
                        <input  
                            id='zipCodeInput'
                            type='text'
                            className="form-control onlyInteger"
                            placeholder="Código postal"
                            name="zipCode"
                            value={ zipCode }
                            onChange={ onInputChange }
                            required 
                        />    
                    </div>                    
                </div> */}



                    <div className='container d-flex align-items-center justify-content-center mt-5 mb-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5">Guardar</button>
                    </div>

                </form>
            </div>

            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
        </div>
    )
}


const PANAMA_COUNTRY_ID = 2;
const PANAMA_ITBMS = '7';
// Moneda (CURRENCY_DEFAULT, sin cero inicial) y límite por transacción por defecto según el país
const CURRENCY_CRC = '188';
const CURRENCY_USD = '840';
const DV_PATTERN = /^\d{1,2}$/;
const PANAMA_DEPOSIT_EMAIL = 'bitacora@swiftpay.one';

const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
